module.exports = __webpack_public_path__ + "img/1716349327945-WhatsApp Image 2024-05-22 at 10.36.48 1.jpeg.6762f079.webp";